import React from 'react';
import type { IconType } from 'react-icons';
import { useTranslation } from 'react-i18next';

export interface EmptyStateProps {
  /** Optional muted leading icon */
  Icon?: IconType;
  /** Pre-translated title; defaults to t('common.noData') */
  title?: string;
  /** Optional second line, e.g. how to create the first item */
  hint?: string;
  className?: string;
}

/**
 * Canonical empty state for lists, tables, and stats surfaces.
 * Prefer a hint that teaches the next action over a bare "no data".
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  Icon,
  title,
  hint,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex flex-col items-center justify-center py-12 text-center ${className}`.trim()}
    >
      {Icon && (
        <Icon
          className="mb-3 h-10 w-10 text-gray-400 dark:text-primary-200"
          aria-hidden="true"
        />
      )}
      <p className="text-gray-500 dark:text-primary-100">
        {title ?? t('common.noData')}
      </p>
      {hint && (
        <p className="mt-1 text-sm text-gray-400 dark:text-primary-200">
          {hint}
        </p>
      )}
    </div>
  );
};
